import TaxDocumentIcon from './TaxDocumentIcon'

export default TaxDocumentIcon
